export default __webpack_public_path__ + "static/media/regulatory--slanted-parking--g1.2c69ce1c.png";